/* eslint-disable max-len */

import { useTranslation } from 'react-i18next';
import { CustomError, ManageCodeLabelColumn } from '../../../../components';
import { infillAlteration } from '../../../../entityModel';
import {
  TXT_DATA_NOT_FOUND,
  TXT_DELETE,
  TXT_EDIT,
  TXT_LOADING
} from '../../../../translations/translationConstants';
import { capitalizeFirstLetter } from '../../../../shared/stringFunctions';
import { getInfillAlterationOutput } from '../../../../api';
import { ApolloError } from '@apollo/client';

export interface ManageInfillAlterationsTableBodyProps {
  error?: ApolloError;
  loading: boolean;
  data?: getInfillAlterationOutput;
  columns: ManageCodeLabelColumn[];
  onEdit: (infillAlteration: infillAlteration) => void;
  onDelete: (infillAlteration: infillAlteration) => void;
}

export const ManageInfillAlterationsTableBody =
  ({ error, columns, loading, data, onEdit, onDelete }: ManageInfillAlterationsTableBodyProps) => {
    const { t } = useTranslation();
    return (
      <tbody>
        {
          loading &&
          <tr>
            <td colSpan={columns.length} style={{ textAlign: 'center' }}>
              <h3>
                {t(TXT_LOADING).toUpperCase()}
              </h3>
            </td>
          </tr>
        }
        {
          !loading && error && error.message &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {error.message}
              </CustomError>
            </td>
          </tr>
        }
        {
          !loading && data &&
          data.infillAlterations && data.infillAlterations.items &&
          data.infillAlterations.items.length > 0 &&
          data.infillAlterations.items.map((infillAlteration) => (
            <tr key={`row-${infillAlteration.id}`}>
              <td>
                {infillAlteration.code}
              </td>
              <td>
                {infillAlteration.label}
              </td>
              <td align='center'>
                <button
                  data-target="#modal-infillAlteration-editor"
                  data-toggle="modal"
                  className='btn btn-primary'
                  aria-label="edit infillAlteration"
                  onClick={() => onEdit(infillAlteration)}>
                  {t(TXT_EDIT).toUpperCase()}
                </button>
              </td>
              <td align='center'>
                <button
                  data-target="#modal-default"
                  data-toggle="modal"
                  className='btn btn-danger'
                  aria-label="delete infillAlteration"
                  type="button"
                  onClick={() => onDelete(infillAlteration)}>
                  {t(TXT_DELETE).toUpperCase()}
                </button>
              </td>
            </tr>
          ))
        }
        {
          !loading &&
          (!data ||
            !data.infillAlterations ||
            !data.infillAlterations.items ||
            data.infillAlterations.items.length <= 0) &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {capitalizeFirstLetter(t(TXT_DATA_NOT_FOUND))}
              </CustomError>
            </td>
          </tr>
        }
      </tbody>
    );
  };
